import { render, staticRenderFns } from "./ModalConta.vue?vue&type=template&id=898f242c&scoped=true&"
import script from "./ModalConta.vue?vue&type=script&setup=true&lang=js&"
export * from "./ModalConta.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898f242c",
  null
  
)

export default component.exports